module.exports = __webpack_public_path__ + "static/media/squareBg.256ac3b8.png";